// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"559b7577","110":"6941e9a8","140":"38df84b6","144":"c1dc2bd5","194":"bc807fc7","243":"6ee54cdf","271":"fceaaa8d","422":"d780d36b","453":"c9161952","619":"944cd990","624":"63e2d667","784":"a805402d","826":"ca42b1bc","841":"1a6dab9b"}[chunkId] + ".chunk.js";
};